"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroup = exports.default = void 0;
var Avatar_1 = require("./Avatar");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Avatar_1).default; } });
var AvatarGroup_1 = require("./AvatarGroup");
Object.defineProperty(exports, "AvatarGroup", { enumerable: true, get: function () { return __importDefault(AvatarGroup_1).default; } });
//# sourceMappingURL=index.js.map